import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  records: {},
  automations: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isCreatingStage: false,
    isUpdatingStage: false,
    isDeletingStage: false,
    isFetchingAutomation: false,
    isUpdatingAutomation: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
